<template>
	<div>
		<div class="no-print">
			<div class="row align-items-center mb-3">
				<div class="col-12 col-md-auto mr-md-auto mb-2 mb-md-0" style="min-width: 0; max-width: 220px;">
					<e-select
						v-model="residence_selected"
						:options="residences"
						:searchable="true"
						label="lieu_label"
						:placeholder="$t('monte.choix_lieu')"
						:loading="loadingLieu"
					>	
						<template slot="singleLabel" slot-scope="{ option }"><span class="lieu-label-ellipsis" :title="option.lieu_label">{{ option.lieu_label }}</span></template>
						<template slot="noOptions">{{ $t('global.list_empty') }}</template>
					</e-select>
				</div>
				<div class="col-12 col-md-auto d-flex align-items-center justify-content-center mb-2 mb-md-0">
					<button class="btn btn-secondary btn-sm" @click="prev"><font-awesome-icon :icon="['fal', 'long-arrow-left']" /></button>
					<div class="d-flex align-items-center mx-2">
						<span class="mr-2 font-weight-bold">{{ date_label }}</span>
						<e-datepicker class="d-inline" v-model="date" id="date" @input="change_date"></e-datepicker>
						<button class="btn btn-sm mx-2" v-bind:class="isToday" @click="change_date_today">{{$t('global.aujourdhui')}}</button>
						<button class="btn btn-primary btn-sm px-3" @click="change_date"><font-awesome-icon :icon="['fal', 'sync']"/></button>
					</div>
					<button class="btn btn-secondary btn-sm" @click="next"><font-awesome-icon :icon="['fal', 'long-arrow-right']" /></button>
				</div>
				<div class="col-12 col-md-auto ml-md-auto d-flex align-items-center" v-if="planning.planning_id">
					<b-button
						variant="secondary"
						class="mr-2"
						:disabled="!planning.planning_id"
						@click="openModalSaillie"
					>{{ $t('monte.saillie_lot') }}</b-button>
					<b-dropdown split variant="primary" @click="printToday" :disabled="!planning.planning_id">
						<template #button-content>
							<font-awesome-icon v-if="print_processing" :icon="['fas', 'spinner']" pulse />{{ $t('monte.imprimer_planning') }}
						</template>
						<b-dropdown-item @click="openModalPrint">{{ $t('monte.imprimer_planning_period') }}</b-dropdown-item>
						<b-dropdown-item v-if="planning.planning_horse" @click="openModalSelectHorse">{{ $t('horse.print_infos_horse') }}</b-dropdown-item>
						<b-dropdown-item @click="openModalCourrierFeuilleSaillie">
							<font-awesome-icon v-if="print_processing_feuille" :icon="['fas', 'spinner']" pulse />{{ $t('monte.imprimer_feuille_saillie') }}
						</b-dropdown-item>
					</b-dropdown>
				</div>
			</div>
			<div class="row">
				<div class="col-12 my-3">
					<div
						v-if="commentaire"
						class="alert mb-0"
						:class="'alert-' + (commentaire_color || comment_color_default)"
						role="button"
						@click="openCommentModal"
					>
						<span class="comment-html" v-html="commentaire"></span>
					</div>
					<button
						v-else
						class="btn btn-outline-secondary btn-block"
						@click.prevent="openCommentModal"
					>
						<font-awesome-icon :icon="['fal', 'plus']" class="mr-1" />{{ $t('monte.add_commentaire') }}
					</button>
				</div>
			</div>

			<template v-if="season.length != 0 && residence_selected.lieu_id && planning.planning_id && !planningLoaded">
				<div class="planning-wrapper" :style="calendarTableStyle">
					<div class="table-calendrier mx-0">
						<div class="row calendar_line no-gutters mt-4 d-none d-md-flex">
							<div class="col-auto calendar_horse_name"><div></div></div>
							<div class="col text-center calendar_horraire" v-for="(schedule, index) in planning.planning_schedule" :key="index">
								{{ schedule.schedule_start }} - {{ schedule.schedule_end }}
							</div>
						</div>

						<div class="row calendar_line no-gutters" v-for="(horse, index) in planning.planning_horse" :key="index">
							<div class="col-12 col-md-auto calendar_horse_name"><div class="text-center text-md-left"><router-link :to="{ name: 'horseFiche', params: { horse_id: horse.horse_id }}">{{ horse.horse_nom }}</router-link><br><a href="#" @click.prevent="openStallionStat(horse.horse_id)"><font-awesome-icon :icon="['far', 'chart-area']" /></a></div></div>
							<div class="col-12 col-md calendar_schedule" v-for="(schedule, index_2) in planning.planning_schedule" :key="index_2">
								<template v-if="Object.keys(planning.infos[horse.horse_id][schedule.schedule_id]).length > 0">
									<div v-if="Object.keys(planning.infos[horse.horse_id][schedule.schedule_id]).length > 1" class="alert alert-danger text-center" role="alert">
										Attention conflit !
									</div>
									<template v-for="(slot, index) in planning.infos[horse.horse_id][schedule.schedule_id]">
										<CellCalendarMainBeta
											v-bind:key="index"
											:schedule="schedule"
											:params="slot"
											:edit_schedule.sync="edit_schedule"
											:delete_schedule.sync="delete_schedule"
											:delete_schedule_force.sync="delete_schedule_force"
										/>
									</template>
								</template>
								<div class="d-flex h-100 justify-content-center align-items-center" v-else>
									<button class="btn btn-secondary mr-2" @click="add(horse.horse_id, schedule.schedule_id)"><font-awesome-icon :icon="['far', 'plus']" /></button>
									<button class="btn btn-secondary" @click="lock_creneau(horse.horse_id, schedule.schedule_id)"><font-awesome-icon :icon="['far', 'lock-open']" /></button>
								</div>
							</div>
						</div>
					</div>
				</div>


			</template>
			<template v-else-if="!initialized || loadingLieu || planningLoaded">
				<LoadingSpinner class="col-12" />
			</template>
			<template v-else>
				<div class="alert alert-warning mt-5">
					{{ $t('monte.no_planning') }}
					<router-link v-if="season.length > 0" :to="{ name: 'seasonPlanningMonte', params: { season_id: season[0].season_id }, query: { lieu_id: residence_selected.lieu_id } }" class="alert-link ml-1">
						{{ $t('monte.no_planning_config_link') }}
					</router-link>
				</div>
			</template>

			<ModalConfirm 
				ref="modal_delete_schedule" 
				:icon="['fal', 'trash-alt']"
				:text_title="$t('monte.modal_title')"
				:text_question="$t('monte.modal_question')"
				:text_message="$t('modal.general.avertissement_suppression')"
				:text_button_ok="$t('action.supprimer')"
				:text_button_cancel="$t('global.annuler')"
				:callback_validation="deleteSchedule"
				:callback_cancel="closeModal" />


		<ModalPrintBeta 
			v-if="season.length != 0"
			ref="modal_print"
			type="main"
			:date="date" 
			:lieu_id="residence_selected.lieu_id"
			:season_id="season[0].season_id"
		/>

		<ModalAddSaillieBeta
			v-if="season.length != 0 && planning.planning_id"
			ref="modal_saillie"
			:date="date" 
			:planning="planning"
			:season_id="season[0].season_id"
			:residence="residence_selected"
			type="REPRO_SAILLIE_EN_MAIN"
		/>

		</div>

		<ModalSelectHorseBeta ref="modal_select_horse" />
		<ModalCourrierFeuilleSaillie ref="modal_courrier_feuille_saillie"/>

		<b-modal ref="modal_comment" size="lg" hide-footer>
			<template #modal-title>{{ $t('horse.commentaire') }}</template>
			<div class="form-group">
				<label for="planning_commentaire_modal">{{ $t('horse.commentaire') }}</label>
				<e-editor-froala
					ref="froala_planning_comment"
					identifier="planning_commentaire_modal"
					:placeholder="$t('horse.commentaire')"
					:content="modal_comment_text"
					@change="updatePlanningCommentEditor"
					:moreText="froala_more_text"
					:enableImage="false"
				></e-editor-froala>
			</div>
			<div class="form-group">
				<label class="d-block">{{ $t('monte.commentaire_color') }}</label>
				<div class="d-flex flex-wrap">
					<button
						v-for="color in comment_colors"
						:key="color"
						type="button"
						class="btn mr-2 mb-2"
						:class="['alert-' + color, modal_comment_color === color ? 'border border-dark font-weight-bold' : '']"
						@click="modal_comment_color = color"
					>
						{{ $t('monte.commentaire_color_' + color) }}
					</button>
				</div>
			</div>
			<div class="d-flex justify-content-between mt-4">
				<button
					type="button"
					class="btn btn-danger"
					:disabled="comment_processing || !commentaire"
					@click="deleteComment"
				>
					<font-awesome-icon v-if="comment_processing" :icon="['fas', 'spinner']" pulse />
					<font-awesome-icon v-else :icon="['fal', 'trash-alt']" class="mr-1" />{{ $t('action.supprimer') }}
				</button>
				<div>
					<button type="button" class="btn btn-secondary mr-2" @click="$refs.modal_comment.hide()">
						{{ $t('global.annuler') }}
					</button>
					<button
						type="button"
						class="btn btn-primary"
						:disabled="comment_processing"
						@click="saveCommentFromModal"
					>
						<font-awesome-icon v-if="comment_processing" :icon="['fas', 'spinner']" pulse />
						<font-awesome-icon v-else :icon="['fal', 'save']" class="mr-1" />{{ $t('global.enregistrer') }}
					</button>
				</div>
			</div>
		</b-modal>
	</div>
</template>

<script type="text/javascript">
	import Vue from 'vue'
	import Navigation from "@/mixins/Navigation.js";
	import PlanningMonte from "@/mixins/PlanningMonte.js"
	import Lieux from '@/mixins/Lieux'
	import ShutterPanel from 'GroomyRoot/components/Utils/ShutterPanel'
	import Shutter from '@/mixins/Shutter'
	import MonteShutters from '@/mixins/shutters-manager/Monte'
	import Gynecologie from '@/mixins/Gynecologie'
	import ShutterGyneco from "@/mixins/shutters-manager/Gyneco.js"
	import { parsePhoneNumberFromString as parseMax, AsYouType } from 'libphonenumber-js/max'

	export default {
		name: 'CalendarMonteMainBeta',
		mixins: [Navigation, PlanningMonte, Lieux, Shutter, MonteShutters, Gynecologie, ShutterGyneco],
		props: {
			planning_date: { type: String, default: null }
		},
		data () {
			return {
				commentaire: "",
				commentaire_color: null,
				comment_processing: false,
				date: new Date(),
				date_label: '',
				planning: {},
				season: [],
				edit_schedule: null,
				delete_schedule: null,
				delete_schedule_force: null,
				schedulehorse_id: null, // créneau que l'on souhaite supprimer dans la modal

				residences: [],
				residence_selected: {},
				initialized: false,
				loadingLieu: false,
				planningLoaded: false,
				print_processing: false,
				print_processing_feuille: false,

				// Edition du commentaire dans la modal
				modal_comment_text: '',
				modal_comment_color: 'info',
				comment_colors: ['info', 'warning', 'danger', 'success'],
				comment_color_default: 'info',
				froala_more_text: ['bold', 'italic', 'underline', 'strikeThrough', 'undo', 'redo', 'formatUL', 'formatOL', 'clearFormatting'],

				events_tab: {
					'PlanningMonte::refresh': this.reloadPlanning,
					'PlanningMonte::ws-reload': this.onWsReload
				},
			}
		},

		mounted() {
			this.init_component()
		},
		computed :{
			isToday:function() {
				let today = new Date
				
				if(this.date.getDate()==today.getDate() && this.date.getMonth()==today.getMonth() && this.date.getFullYear()==today.getFullYear()){
					return "btn-primary"
				}
				return "btn-outline-primary"
			},
			dateFormat:function() {
				return new Intl.DateTimeFormat('fr', { dateStyle: 'full'}).format(this.date);
			},
			getNow: function() {
                    let today = new Date();
                    let date = new Intl.DateTimeFormat('fr').format(today);
                    let time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
                    let dateTime = date +' '+ time;
                    return dateTime;
            },
			calendarTableStyle: function() {
				const count = this.planning && this.planning.planning_schedule ? this.planning.planning_schedule.length : 0
				return { '--cal-min-width': (50 + count * 370) + 'px' }
			}
		},
		methods: {
			async init_component() {

				this.date = this.planning_date ? new Date(this.planning_date) : new Date();
				const residence = this.getConfig('lastResidencePlanningMain')
				this.season = await this.getCurrentSeason(this.date)
				if(residence !== null) {
					this.residence_selected = residence
				}

				this.formatDate()
				this.loadResidence() 
			},
			formatPhone(number) {
				return new AsYouType(Vue.i18n.locale()).input(number)
			},
			formatDate() {
				this.date_label = this.getTrad("monte.jours."+this.date.getDay())
			},

			/**
			 * Sauvegarde le commentaire de la journée et notifie les autres clients via WebSocket
			 */
			async saveComment() {
				this.comment_processing = true
				await this.savePlanningComment(this.commentaire, this.residence_selected.lieu_id, this.date)
				this.comment_processing = false
				this._wsPlanningRefresh()
			},

			/**
			 * Ouvre la modal d'édition du commentaire en pré-remplissant texte et couleur
			 */
			openCommentModal() {
				this.modal_comment_text = this.commentaire
				this.modal_comment_color = this.commentaire_color || this.comment_color_default
				this.$refs.modal_comment.show()
				this.$nextTick(() => {
					if(this.$refs.froala_planning_comment) {
						this.$refs.froala_planning_comment.setValue(this.modal_comment_text)
					}
				})
			},

			/**
			 * Synchronise le contenu édité dans Froala
			 */
			updatePlanningCommentEditor(hook) {
				this.modal_comment_text = hook.val
			},

			/**
			 * Sauvegarde le commentaire depuis la modal (texte et couleur sont stockés séparément en BDD)
			 */
			async saveCommentFromModal() {
				this.comment_processing = true
				const html = this.modal_comment_text || ''
				// Considère le commentaire vide si Froala renvoie son balisage vide
				const stripped = html.replace(/<[^>]+>/g, '').replace(/&nbsp;/g, '').trim()
				const text_payload = stripped ? html : ''
				const color_payload = stripped ? this.modal_comment_color : null
				await this.savePlanningComment(text_payload, color_payload, this.residence_selected.lieu_id, this.date)
				this.commentaire = text_payload
				this.commentaire_color = color_payload
				this.comment_processing = false
				this.$refs.modal_comment.hide()
				this._wsPlanningRefresh()
			},

			/**
			 * Supprime (vide) le commentaire courant
			 */
			async deleteComment() {
				this.comment_processing = true
				await this.savePlanningComment('', null, this.residence_selected.lieu_id, this.date)
				this.commentaire = ''
				this.commentaire_color = null
				this.modal_comment_text = ''
				this.modal_comment_color = this.comment_color_default
				this.comment_processing = false
				this.$refs.modal_comment.hide()
				this._wsPlanningRefresh()
			},

			async loadResidence() {
				this.initialized = true
				this.loadingLieu = true

				if(this.season.length === 0) {
					this.loadingLieu = false
					return
				}

				this.residences = await this.getResidences()
				if(Object.entries(this.residence_selected).length == 0) {
					const default_planning = await this.getResidencePlanningDefault(this.season[0].season_id, "main")
					if (default_planning) {
						this.residence_selected = this.residences.find(lieu => lieu.lieu_id == default_planning.planning_lieu) || {}
					}
				}
				this.loadingLieu = false
			},

			async loadPlanning() {
				this.planningLoaded = true
				this.planning = {}
				this.commentaire = ''
				this.commentaire_color = null
				if(this.season.length != 0){
					const planning = await this.getPlanningOnline(this.season[0].season_id, "main", this.date, this.residence_selected.lieu_id)
					this.setConfig('lastResidencePlanningMain', this.residence_selected)
					if(planning.date == this.date.toDateInputValue()) {
						this.planning = planning
					}
					this.commentaire = planning.commentaire
					this.commentaire_color = planning.commentaire_color || null
				}
				this.planningLoaded = false
			},

			async prev() {
				let date = new Date(this.date.getTime())
				date.setDate(date.getDate() - 1)
				this.date = date
				this.formatDate()
				this.season = await this.getCurrentSeason(this.date)
				this.loadPlanning()
			},

			async next() {
				let date = new Date(this.date.getTime())
				date.setDate(date.getDate() + 1)
				this.date = date
				this.formatDate()
				this.season = await this.getCurrentSeason(this.date)
				this.loadPlanning()
			},

			add(horse_id, schedule_id) {
                this.shutterPanel().keepGiven('monte-main-calendar-beta')

				const shutter = this.monteShutters['monte-main-ajout-beta']
				shutter.props.schedule_id = schedule_id
				shutter.props.horse_id = horse_id
				shutter.props.planning_id = this.planning.planning_id
				shutter.props.date_preselected = this.date
				shutter.props.season_id = this.season[0].season_id
				shutter.props.stallions = this.planning.planning_horse
				shutter.props.schedules = this.planning.planning_schedule

				shutter.props.schedule_info = null

				shutter.onOk = () => {
					this.loadPlanning()
					this._wsPlanningRefresh()
				}

				this.shutterPanel().open(shutter)
			},

			async deleteSchedule() {
				await this.deleteScheduleOnline('main', this.schedulehorse_id)
				this.closeModal()
				this.loadPlanning()
				this._wsPlanningRefresh()
			},

			closeModal() {
				this.schedulehorse_id = null
				this.$refs.modal_delete_schedule.closeModal()
			},

			openModalPrint() {
				this.$refs.modal_print.openModal()
			},

			openModalSaillie() {
				this.$refs.modal_saillie.openModal()
			},

			async change_date() {
				this.formatDate()
				this.season = await this.getCurrentSeason(this.date)
				this.loadResidence()
			},
			change_date_today() {
				this.date = new Date()
				this.change_date()
			},
			openModalSelectHorse() {
				this.$refs.modal_select_horse.openModal(this.planning)
			},
			async printToday() {
                this.print_processing = true
                await this.printPlanningDay(this.season[0].season_id, 'main', this.residence_selected.lieu_id, this.date.toDateInputValue())
                this.print_processing = false
			},
			async reloadPlanning() {
				this.planningLoaded = true
				this.planning = {}
				this.loadPlanning()
			},

			onWsReload({ date, lieu_id }) {
				if (!this.residence_selected || !this.residence_selected.lieu_id) return
				if (date === this.date.toDateInputValue() && lieu_id === this.residence_selected.lieu_id) {
					this.loadPlanning()
				}
			},

			_wsPlanningRefresh() {
				if (!this.residence_selected || !this.residence_selected.lieu_id) return
				this.$sync.websocketPushCustom(`planning-monte:reload:${this.date.toDateInputValue()}:${this.residence_selected.lieu_id}`)
			},

			openStallionStat(horse_id) {
				this.setupStatSaillies(horse_id)
			},

			async lock_creneau(horse_id, schedule_id) {
				await this.saveScheduleHorseOnline("main", horse_id, schedule_id, null, null, this.date, null, '', null)
				this.loadPlanning()
				this._wsPlanningRefresh()
			},
			
			openModalCourrierFeuilleSaillie() {
				this.print_processing_feuille = true
				const params = {
					season_id: this.season[0].season_id,
					type: 'main',
					lieu_id: this.residence_selected.lieu_id,
					date: this.date.toDateInputValue(),
					infos: this.planning.infos,
					schedule: this.planning.planning_schedule
				}

				this.$refs.modal_courrier_feuille_saillie.openModal(params)
				this.print_processing_feuille = false
			},
		},

		watch: {
			edit_schedule (obj) {
				if(!obj) return false

                this.shutterPanel().keepGiven('monte-main-calendar-beta')

				const shutter = this.monteShutters['monte-main-ajout-beta']
				shutter.props.schedule_info = obj.schedule_info
				shutter.props.schedule_id = obj.schedule_id
				shutter.props.horse_id = obj.horse_id
				shutter.props.season_id = this.season[0].season_id
				shutter.props.planning_id = this.planning.planning_id
				shutter.props.stallions = this.planning.planning_horse
				shutter.props.schedules = this.planning.planning_schedule

				shutter.onOk = () => {
					this.loadPlanning()
					this._wsPlanningRefresh()
				}

				this.shutterPanel().open(shutter)
			},

			delete_schedule (schedulehorse_id) {
				this.schedulehorse_id = schedulehorse_id.schedulehorse_id
				this.$refs.modal_delete_schedule.openModal()
			},

			delete_schedule_force (schedulehorse_id) {
				this.schedulehorse_id = schedulehorse_id.schedulehorse_id
				this.deleteSchedule()
			},

			residence_selected() {
				this.loadPlanning()
			}
		},

		components: {
			CellCalendarMainBeta : () => import('@/components/Monte/CellCalendarMainBeta'),
			ModalConfirm: () => import('GroomyRoot/components/Modals/ModalConfirm'),
			ModalPrintBeta : () => import('@/components/Monte/ModalPrintBeta'),
			ModalAddSaillieBeta: () => import('@/components/Monte/ModalAddSaillieBeta'),
			ModalSelectHorseBeta : () => import('@/components/Monte/ModalSelectHorseBeta'),
			LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
			ModalCourrierFeuilleSaillie: () => import('@/components/Modals/ModalCourrierFeuilleSaillie'),
		}
	}

</script>

<style scoped>
::v-deep .multiselect__option span {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	display: block;
}
</style>